import { createClient } from "@supabase/supabase-js";

/*
 * ============================================
 * PROFILES TABLE RLS POLICIES
 * ============================================
 * Run these in Supabase SQL editor
 *
 * -- Enable RLS if not already enabled
 * ALTER TABLE profiles ENABLE ROW LEVEL SECURITY;
 *
 * -- Drop existing policies first to avoid conflicts
 * DROP POLICY IF EXISTS "Users can view own profile"    ON profiles;
 * DROP POLICY IF EXISTS "Users can update own profile"  ON profiles;
 * DROP POLICY IF EXISTS "Users can insert own profile"  ON profiles;
 * DROP POLICY IF EXISTS "Admins can view all profiles"  ON profiles;
 * DROP POLICY IF EXISTS "Admins can update all profiles" ON profiles;
 *
 * -- Users can only read their own profile
 * CREATE POLICY "Users can view own profile"
 *   ON profiles FOR SELECT
 *   USING (auth.uid() = id);
 *
 * -- Users can only update their own profile
 * CREATE POLICY "Users can update own profile"
 *   ON profiles FOR UPDATE
 *   USING (auth.uid() = id)
 *   WITH CHECK (auth.uid() = id);
 *
 * -- Users can insert their own profile on signup
 * CREATE POLICY "Users can insert own profile"
 *   ON profiles FOR INSERT
 *   WITH CHECK (auth.uid() = id);
 *
 * -- Admins can read all profiles
 * -- (assumes admins have role = 'admin' in profiles)
 * CREATE POLICY "Admins can view all profiles"
 *   ON profiles FOR SELECT
 *   USING (
 *     EXISTS (
 *       SELECT 1 FROM profiles
 *       WHERE id = auth.uid()
 *       AND role = 'admin'
 *     )
 *   );
 *
 * -- Admins can update all profiles
 * CREATE POLICY "Admins can update all profiles"
 *   ON profiles FOR UPDATE
 *   USING (
 *     EXISTS (
 *       SELECT 1 FROM profiles
 *       WHERE id = auth.uid()
 *       AND role = 'admin'
 *     )
 *   );
 *
 * -- Service role bypasses RLS for edge functions
 */

const url = import.meta.env.VITE_SUPABASE_URL!;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY!;

export const supabase = createClient(url, key, { auth: { storageKey: "fyrris-auth" } });
